import React, { Component } from 'react';

class NoMatch extends Component {
  render() {
    return (
      <div className="App">
        <p className="App-intro">
          Not Found
        </p>
      </div>
    );
  }
}

export default NoMatch;



/** WEBPACK FOOTER **
 ** ./src/components/NoMatch.js
 **/